import { createTheme } from '@mui/material/styles';
import { CurrentFont } from './themeColors';

export const themeMui = createTheme({
  typography: {
    fontFamily: CurrentFont.fontFamily
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: CurrentFont.fontFamily,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0px 4px 8px rgba(75, 78, 81, 0.2)'
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0,
        }
      }
    }
  },
});
